import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';
import { RMS_SHEET_MODAL_CLASS } from '../../constants/sheet-modal';

@Component({
    selector: 'rms-delete-confirmation',
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.scss'],
    standalone: false
})
export class DeleteConfirmationComponent {

  @ViewChild('deleteConfirmationModal', { static: true }) modal: ElementRef;
  private modalRef: NgbModalRef;

  public isTradeRestriction: boolean;
  public removalReason: string;
  public data: any;
  public maxEndDate: DateTime = DateTime.now().toLocal();
  public endDate: DateTime = DateTime.now().toLocal();
  public forceEzeError = false;

  public readonly environment = environment;

  constructor(private modalService: NgbModal) { }

  public openModal(isTradeRestriction: boolean) {
    this.isTradeRestriction = isTradeRestriction;
    this.removalReason = '';
    this.forceEzeError = false;
    this.modalRef = this.modalService.open(this.modal, { size: 'md', centered: true, fullscreen: 'sm', windowClass: RMS_SHEET_MODAL_CLASS });
    return this.modalRef;
  }

  public submit(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.modalRef.close({
      endDate: this.endDate,
      forceEzeError: this.forceEzeError,
      ...(this.isTradeRestriction ? {'reason': this.removalReason} : {})
    });
  }
}
